import { PriceChangeEnum } from './../constants/enums/priceChange';
import { IPartnerConfig } from "src/constants/interfaces";
import { composeAND } from "./strategy";
import { IClientConfig } from "src/client-config/config";
import { BetTypeEnum } from "src/constants/enums/betType";
import { IMainStore } from "src/stores/main";
import { ISelection } from "src/constants/interfaces/bet";
import { virtualSportTypeIds } from 'src/constants/enums/virtualSportTypes'
import { GameTypeEnum } from "src/constants/enums/gameType";

const counterOfferEnabled = (config: IClientConfig,
  mainStore: IMainStore,
  partnerConfig: IPartnerConfig | undefined,
  selection: ISelection) => config.enableCounterOffer && (selection.game.type !== GameTypeEnum.Live || !config.disableCounterOfferOnLive);

const betTypeCompatible = (config: IClientConfig, mainStore: IMainStore) => (
  (config.enableCounterOffer && mainStore.betType === BetTypeEnum.Single) ||
  (config.enableExpressCounterOffer && mainStore.betType === BetTypeEnum.Multiple)
)

const notRacing = (
  config: IClientConfig,
  mainStore: IMainStore,
  partnerConfig: IPartnerConfig | undefined,
  selection: ISelection
) => !selection.event.isRacingEvent;

const partnerHasCounterOffer = (
  config: IClientConfig,
  mainStore: IMainStore,
  partnerConfig: IPartnerConfig | undefined
) => !!partnerConfig?.is_counter_offer_available && !!partnerConfig?.odds_raised_percent;

const notVirtual = (config: IClientConfig,
  mainStore: IMainStore,
  partnerConfig: IPartnerConfig | undefined, selection: ISelection) => !virtualSportTypeIds.includes(selection.game.sport?.id || 0)

export const counterOfferAvailable = composeAND(notRacing, notVirtual, partnerHasCounterOffer, counterOfferEnabled, betTypeCompatible);


export const invalidCounterOfferOdd = (selection: ISelection) => {
  const alternateOdd = selection.alternateOdd || 0;
  return (
    selection.priceChangeType === PriceChangeEnum.CounterOffer &&
    alternateOdd > 0 && alternateOdd < selection.event.price
  );
}